/*
 * @Description: Do not edit
 * @Author: Do not edit
 * @Date: 2019-10-27 16:30:20
 * @LastEditTime: 2019-11-05 16:50:52
 * @LastEditors: he.jianbo
 */
'use strict';
angular.module('H5ToolBindAccountServiceModule', ['H5ToolBindAccountModule'])
    .factory('H5ToolBindAccountService', ['$q', '$modal', function($q, $modal) {
        return {

            /**
             * [AccountAdd description]添加H5工具账号
             *
             * @param   {[type]}  success  [success description]
             *
             * @return  {function}         [return description]
             */
            AccountAdd: function(success) {
                var modalInstance = $modal.open({
                    templateUrl: './manageConfig/tenantManageMent/service/setBillingModule/H5ToolBindAccount/H5ToolBindAccount_tpl.html',
                    windowClass: 'weibo-account-add',
                    backdrop: false,
                    controller: 'H5ToolBindAccountCtrl'
                });
                modalInstance.result.then(function(result) {
                    success(result);
                });
            }
        };
    }]);
